export default __webpack_public_path__ + "static/media/Iara.38f3f8fb.png";